function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/styles/border
 */
import { getShorthandValues, getBoxSidesValueReducer, getBoxSidesValues, isLength, isLineStyle } from './utils';
/**
 * Adds a border CSS styles processing rules.
 *
 *		editor.data.addStyleProcessorRules( addBorderRules );
 *
 * This rules merges all [border](https://developer.mozilla.org/en-US/docs/Web/CSS/border) styles notation shorthands:
 *
 * - border
 * - border-top
 * - border-right
 * - border-bottom
 * - border-left
 * - border-color
 * - border-style
 * - border-width
 *
 * and all corresponding longhand forms (like `border-top-color`, `border-top-style`, etc).
 *
 * It does not handle other shorthands (like `border-radius` or `border-image`).
 *
 * The normalized model stores border values as:
 *
 *		const styles = {
 *			border: {
 *				color: { top, right, bottom, left },
 *				style: { top, right, bottom, left },
 *				width: { top, right, bottom, left },
 *			}
 *		};
 *
 * @param {module:engine/view/stylesmap~StylesProcessor} stylesProcessor
 */

export function addBorderRules(stylesProcessor) {
  stylesProcessor.setNormalizer('border', borderNormalizer); // Border-position shorthands.

  stylesProcessor.setNormalizer('border-top', getBorderPositionNormalizer('top'));
  stylesProcessor.setNormalizer('border-right', getBorderPositionNormalizer('right'));
  stylesProcessor.setNormalizer('border-bottom', getBorderPositionNormalizer('bottom'));
  stylesProcessor.setNormalizer('border-left', getBorderPositionNormalizer('left')); // Border-property shorthands.

  stylesProcessor.setNormalizer('border-color', getBorderPropertyNormalizer('color'));
  stylesProcessor.setNormalizer('border-width', getBorderPropertyNormalizer('width'));
  stylesProcessor.setNormalizer('border-style', getBorderPropertyNormalizer('style')); // Border longhands.

  stylesProcessor.setNormalizer('border-top-color', getBorderPropertyPositionNormalizer('color', 'top'));
  stylesProcessor.setNormalizer('border-top-style', getBorderPropertyPositionNormalizer('style', 'top'));
  stylesProcessor.setNormalizer('border-top-width', getBorderPropertyPositionNormalizer('width', 'top'));
  stylesProcessor.setNormalizer('border-right-color', getBorderPropertyPositionNormalizer('color', 'right'));
  stylesProcessor.setNormalizer('border-right-style', getBorderPropertyPositionNormalizer('style', 'right'));
  stylesProcessor.setNormalizer('border-right-width', getBorderPropertyPositionNormalizer('width', 'right'));
  stylesProcessor.setNormalizer('border-bottom-color', getBorderPropertyPositionNormalizer('color', 'bottom'));
  stylesProcessor.setNormalizer('border-bottom-style', getBorderPropertyPositionNormalizer('style', 'bottom'));
  stylesProcessor.setNormalizer('border-bottom-width', getBorderPropertyPositionNormalizer('width', 'bottom'));
  stylesProcessor.setNormalizer('border-left-color', getBorderPropertyPositionNormalizer('color', 'left'));
  stylesProcessor.setNormalizer('border-left-style', getBorderPropertyPositionNormalizer('style', 'left'));
  stylesProcessor.setNormalizer('border-left-width', getBorderPropertyPositionNormalizer('width', 'left'));
  stylesProcessor.setExtractor('border-top', getBorderPositionExtractor('top'));
  stylesProcessor.setExtractor('border-right', getBorderPositionExtractor('right'));
  stylesProcessor.setExtractor('border-bottom', getBorderPositionExtractor('bottom'));
  stylesProcessor.setExtractor('border-left', getBorderPositionExtractor('left'));
  stylesProcessor.setExtractor('border-top-color', 'border.color.top');
  stylesProcessor.setExtractor('border-right-color', 'border.color.right');
  stylesProcessor.setExtractor('border-bottom-color', 'border.color.bottom');
  stylesProcessor.setExtractor('border-left-color', 'border.color.left');
  stylesProcessor.setExtractor('border-top-width', 'border.width.top');
  stylesProcessor.setExtractor('border-right-width', 'border.width.right');
  stylesProcessor.setExtractor('border-bottom-width', 'border.width.bottom');
  stylesProcessor.setExtractor('border-left-width', 'border.width.left');
  stylesProcessor.setExtractor('border-top-style', 'border.style.top');
  stylesProcessor.setExtractor('border-right-style', 'border.style.right');
  stylesProcessor.setExtractor('border-bottom-style', 'border.style.bottom');
  stylesProcessor.setExtractor('border-left-style', 'border.style.left');
  stylesProcessor.setReducer('border-color', getBoxSidesValueReducer('border-color'));
  stylesProcessor.setReducer('border-style', getBoxSidesValueReducer('border-style'));
  stylesProcessor.setReducer('border-width', getBoxSidesValueReducer('border-width'));
  stylesProcessor.setReducer('border-top', getBorderPositionReducer('top'));
  stylesProcessor.setReducer('border-right', getBorderPositionReducer('right'));
  stylesProcessor.setReducer('border-bottom', getBorderPositionReducer('bottom'));
  stylesProcessor.setReducer('border-left', getBorderPositionReducer('left'));
  stylesProcessor.setReducer('border', getBorderReducer());
  stylesProcessor.setStyleRelation('border', ['border-color', 'border-style', 'border-width', 'border-top', 'border-right', 'border-bottom', 'border-left', 'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color', 'border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width']);
  stylesProcessor.setStyleRelation('border-color', ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color']);
  stylesProcessor.setStyleRelation('border-style', ['border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style']);
  stylesProcessor.setStyleRelation('border-width', ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width']);
  stylesProcessor.setStyleRelation('border-top', ['border-top-color', 'border-top-style', 'border-top-width']);
  stylesProcessor.setStyleRelation('border-right', ['border-right-color', 'border-right-style', 'border-right-width']);
  stylesProcessor.setStyleRelation('border-bottom', ['border-bottom-color', 'border-bottom-style', 'border-bottom-width']);
  stylesProcessor.setStyleRelation('border-left', ['border-left-color', 'border-left-style', 'border-left-width']);
}

function borderNormalizer(value) {
  var _normalizeBorderShort = normalizeBorderShorthand(value),
      color = _normalizeBorderShort.color,
      style = _normalizeBorderShort.style,
      width = _normalizeBorderShort.width;

  return {
    path: 'border',
    value: {
      color: getBoxSidesValues(color),
      style: getBoxSidesValues(style),
      width: getBoxSidesValues(width)
    }
  };
}

function getBorderPositionNormalizer(side) {
  return function (value) {
    var _normalizeBorderShort2 = normalizeBorderShorthand(value),
        color = _normalizeBorderShort2.color,
        style = _normalizeBorderShort2.style,
        width = _normalizeBorderShort2.width;

    var border = {};

    if (color !== undefined) {
      border.color = _defineProperty({}, side, color);
    }

    if (style !== undefined) {
      border.style = _defineProperty({}, side, style);
    }

    if (width !== undefined) {
      border.width = _defineProperty({}, side, width);
    }

    return {
      path: 'border',
      value: border
    };
  };
}

function getBorderPropertyNormalizer(propertyName) {
  return function (value) {
    return {
      path: 'border',
      value: toBorderPropertyShorthand(value, propertyName)
    };
  };
}

function toBorderPropertyShorthand(value, property) {
  return _defineProperty({}, property, getBoxSidesValues(value));
}

function getBorderPropertyPositionNormalizer(property, side) {
  return function (value) {
    return {
      path: 'border',
      value: _defineProperty({}, property, _defineProperty({}, side, value))
    };
  };
}

function getBorderPositionExtractor(which) {
  return function (name, styles) {
    if (styles.border) {
      return extractBorderPosition(styles.border, which);
    }
  };
}

function extractBorderPosition(border, which) {
  var value = {};

  if (border.width && border.width[which]) {
    value.width = border.width[which];
  }

  if (border.style && border.style[which]) {
    value.style = border.style[which];
  }

  if (border.color && border.color[which]) {
    value.color = border.color[which];
  }

  return value;
}

function normalizeBorderShorthand(string) {
  var result = {};
  var parts = getShorthandValues(string);

  var _iterator = _createForOfIteratorHelper(parts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (isLength(part) || /thin|medium|thick/.test(part)) {
        result.width = part;
      } else if (isLineStyle(part)) {
        result.style = part;
      } else {
        result.color = part;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
} // The border reducer factory.
//
// It tries to produce the most optimal output for the specified styles.
//
// For border style:
//
//      style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
//
// It will produce: `border-style: solid` output.
// For border style and color:
//
//      color: {top: "#ff0", bottom: "#ff0", right: "#ff0", left: "#ff0"}
//      style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
//
// It will produce: `border-color: #ff0; border-style: solid`
// If all border parameters are specified:
//
//      color: {top: "#ff0", bottom: "#ff0", right: "#ff0", left: "#ff0"}
//      style: {top: "solid", bottom: "solid", right: "solid", left: "solid"}
//      width: {top: "2px", bottom: "2px", right: "2px", left: "2px"}
//
// It will combine everything into the single property: `border: 2px solid #ff0`.
//
// Definitions are merged only if all border selectors have the same values.
//
// @returns {Function}


function getBorderReducer() {
  return function (value) {
    var topStyles = extractBorderPosition(value, 'top');
    var rightStyles = extractBorderPosition(value, 'right');
    var bottomStyles = extractBorderPosition(value, 'bottom');
    var leftStyles = extractBorderPosition(value, 'left');
    var borderStyles = [topStyles, rightStyles, bottomStyles, leftStyles];
    var borderStylesByType = {
      width: getReducedStyleValueForType(borderStyles, 'width'),
      style: getReducedStyleValueForType(borderStyles, 'style'),
      color: getReducedStyleValueForType(borderStyles, 'color')
    }; // Try reducing to a single `border:` property.

    var reducedBorderStyle = reduceBorderPosition(borderStylesByType, 'all');

    if (reducedBorderStyle.length) {
      return reducedBorderStyle;
    } // Try reducing to `border-style:`, `border-width:`, `border-color:` properties.


    var reducedStyleTypes = Object.entries(borderStylesByType).reduce(function (reducedStyleTypes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          type = _ref3[0],
          value = _ref3[1];

      if (value) {
        reducedStyleTypes.push(["border-".concat(type), value]); // Remove it from the full set to not include it in the most specific properties later.

        borderStyles.forEach(function (style) {
          return style[type] = null;
        });
      }

      return reducedStyleTypes;
    }, []); // The reduced properties (by type) and all the rest that could not be reduced.

    return [].concat(_toConsumableArray(reducedStyleTypes), _toConsumableArray(reduceBorderPosition(topStyles, 'top')), _toConsumableArray(reduceBorderPosition(rightStyles, 'right')), _toConsumableArray(reduceBorderPosition(bottomStyles, 'bottom')), _toConsumableArray(reduceBorderPosition(leftStyles, 'left')));
  }; // @param {Array.<Object>} styles The array of objects with `style`, `color`, `width` properties.
  // @param {'width'|'style'|'color'} type

  function getReducedStyleValueForType(styles, type) {
    return styles.map(function (style) {
      return style[type];
    }).reduce(function (result, style) {
      return result == style ? result : null;
    });
  }
}

function getBorderPositionReducer(which) {
  return function (value) {
    return reduceBorderPosition(value, which);
  };
} // Returns an array with reduced border styles depending on specified values.
//
// If all (width, style, color) border properties are specified, the returned selector will be
// merged into the group: `border-*: [width] [style] [color]`.
//
// Otherwise, the specific definitions will be returned: `border-(width|style|color)-*: [value]`.
//
// @param {Object|null} value Styles if defined.
// @param {'top'|'right'|'bottom'|'left'|'all'} which The border position.
// @returns {Array}


function reduceBorderPosition(value, which) {
  var borderTypes = [];

  if (value && value.width) {
    borderTypes.push('width');
  }

  if (value && value.style) {
    borderTypes.push('style');
  }

  if (value && value.color) {
    borderTypes.push('color');
  }

  if (borderTypes.length == 3) {
    var borderValue = borderTypes.map(function (item) {
      return value[item];
    }).join(' ');
    return [which == 'all' ? ['border', borderValue] : ["border-".concat(which), borderValue]];
  } // We are unable to reduce to a single `border:` property.


  if (which == 'all') {
    return [];
  }

  return borderTypes.map(function (type) {
    return ["border-".concat(which, "-").concat(type), value[type]];
  });
}